export const ENUMS = {
  productSetup: {
    contractType: 'CONTRACT_TYPE',
    utility: 'UTILITY',
    commodity: 'COMMODITY',
    unit: 'UNIT',
    brand: 'BRAND_TYPE',
    customerType: 'CUSTOMER_TYPE',
  },
  product: {
    commodity: {
      Dual: 'Dual',
      Electric: 'Electric',
      Gas: 'Gas',
    },
  },
}
